import styled from 'styled-components';
import colors from '../../../config/colors.json';

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`;

export const Icon = styled.svg`
    fill: none;
    stroke: ${colors.light};
    stroke-width: 3px;
`;

export const StyledCheckbox = styled.div`
    display: inline-block;
    width: 20px;
    height: 20px;
    background: ${props => (props.checked ? colors.lightRed : 'transparent')};
    border: ${props => (props.checked ? `1px solid ${colors.lightRed}` : `1px solid ${colors.lightGrey}`)};
    border-radius: 3px;
    transition: all 150ms;
    margin-right: 5px;
    ${Icon} {
        transition: opacity ease-in-out 150ms;
        opacity: ${props => (props.checked ? 1 : 0)};
    }
`;

export const CheckboxContainer = styled.div`
    display: flex;
    vertical-align: middle;
`;
